/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {string} str
 * @returns {Boolean}
 * 统一社会信用代码用18位阿拉伯数字或大写英文字母表示
 */
export function organizationCodeRegExp(str) {
  let regExp = /^[0-9A-Z]{18}$/
  return !regExp.test(str)
}

/**
 * 校验姓名非法字符
 * @param {string} name
 * @returns {Boolean}
 */
export function validName(name) {
  const reg = /[`~!@$%^&*()=+[\]{}\\|;:'"<>?/！￥…（）—【】、；：‘’“”，《。》？～＠＃％＆×－＝＋｛｝＼｜｀＄＾＊＿［］＇＂＜．＞／]+/
  return reg.test(name)
}

/**
 * 校验手机号
 * @param {string} phone
 * @returns {Boolean}
 */
export function validMobile(phone) {
  const reg = /^1[0-9]{10}$/
  return !reg.test(phone)
}

/**
 * 校验固定电话
 * @param {string} phone
 * @returns {Boolean}
 */
export function validFixedPhone(phone) {
  const reg = /^([0-9]{3,4}-)?[0-9]{7,8}(-[0-9]{1,4})?$/
  return !reg.test(phone)
}

/**
 * 邮政编码
 * @param {string} value
 * @returns {Boolean}
 */
export function validPostCode(value) {
  const reg = /^[0-9]{6}$/
  return !reg.test(value)
}

/**
 * 邮箱
 * @param {string} value
 * @returns {Boolean}
 */
export function validEmail(value) {
  const reg = /^.{1,49}@.{1,49}$/
  return !reg.test(value)
}